import React from "react";
import { withTranslation } from "react-i18next";
import { VehicleView } from "./vehicleView";

class VehicleViewParent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }
    render() {
        return <VehicleView {...this?.props} />;
    }
}

export default withTranslation('Vehicle')(VehicleViewParent);

